import { CodingExamStatics } from '../../../../../../../store/workspace/types';
import MotionWrapper from '../../../../../../../layouts/MotionWrapper';
import { CodeBlock, dracula } from 'react-code-blocks';
import { useEffect, useState } from 'react';
import Accordion from '../../../../components/Accordion';
import EmptyState from '../../../../components/EmptyState';
import { CODING_QUESTION_INDEXES } from '../../../../constants';
import { useAccordions } from '../../../../hooks/useAccordions';
import styles from './style.module.scss';

interface Props {
    jobTitle: string;
    examData: CodingExamStatics | null;
};

export default function CodingExamSheet(props: Props) {
    const { jobTitle, examData } = props;

    const { isOpen, toggle } = useAccordions();
    const [selectedLang, setSelectedLang] = useState('');

    const languageQuestions = examData?.exam?.questions.find(item => selectedLang in item);
    const questions = languageQuestions ? languageQuestions[selectedLang] : [];

    useEffect(() => {
        setSelectedLang(examData ? examData.exam.languages[0] : '');
    }, [examData]);

    if (!examData) {
        return (
            <MotionWrapper className={styles.container}>
                <EmptyState className={styles.empty_state} />
            </MotionWrapper>
        );
    }

    return (
        <MotionWrapper className={styles.container}>
            <div className={styles.detail}>
                <div className={styles.header}>
                    <div className={styles.header_top}>
                        <span className={styles.header_top_title}>{jobTitle}</span>
                    </div>
                    <div className={styles.header_bottom}>
                        <span className={styles.header_bottom_item}>
                            Question Quantities : {examData.exam.countQuestions}
                        </span>
                        <span className={styles.header_bottom_item}>
                            Exam Time : {examData.exam.time}'
                        </span>
                        <span className={styles.header_bottom_item}>
                            Coding Languages : {examData.exam.languages.map(language => <span
                                key={language}
                                onClick={() => setSelectedLang(language)}
                                className={styles.header_bottom_item_lang}
                                data-is-selected={selectedLang === language}
                            >
                                {language}
                            </span>)}
                        </span>
                    </div>
                </div>

                {CODING_QUESTION_INDEXES.map(questionIndex => <div className={styles.question_data} key={questionIndex}>
                    <span>Question {questionIndex + 1}:</span>

                    <Accordion
                        preformatted
                        title='Description'
                        open={isOpen(`description-${questionIndex}`)}
                        onToggle={() => toggle(`description-${questionIndex}`)}
                    >
                        {questions[questionIndex]?.description}
                    </Accordion>

                    <Accordion
                        title='Test Cases:'
                        open={isOpen(`tests-${questionIndex}`)}
                        onToggle={() => toggle(`tests-${questionIndex}`)}
                    >
                        <CodeBlock
                            theme={dracula}
                            showLineNumbers={true}
                            language={examData.exam.languages[0]}
                            text={questions[questionIndex]?.test_cases}
                        />
                    </Accordion>
                </div>)}
            </div>
        </MotionWrapper>
    );
};
